import * as React from 'react';
import type { SVGProps } from 'react';
const SvgDenialDocument = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={20}
    height={20}
    fill="none"
    viewBox="0 0 20 20"
    {...props}
  >
    <path
      fill="#3752B3"
      fillRule="evenodd"
      d="m11.626 2.992 3.757 4.025c.287.308.45.733.45 1.175v7.641c0 .917-.7 1.667-1.555 1.667H5.715c-.856 0-1.548-.75-1.548-1.667l.008-11.666c0-.917.692-1.667 1.548-1.667h4.798c.413 0 .81.175 1.105.492m-.459 5.341h3.5L10.389 3.75V7.5c0 .458.35.833.778.833"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgDenialDocument;
